import {
    GET_SUB_CONTRACTOR_STAGE_ACCESS_LOADING,
    GET_SUB_CONTRACTOR_STAGE_ACCESS_SUCCESS,
    GET_SUB_CONTRACTOR_STAGE_ACCESS_FAILURE,
} from '../../actions/types';

const INITIAL_STATE = {
    subContractorStageAccess: {
        get: {
            loading: false,
            reset: false,
            success: {
                ok: false,
                data: null,
            },
            failure: {
                error: false,
                message: '',
            },
        }
    }
};

const subContractorStageAccessReducers = (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case  GET_SUB_CONTRACTOR_STAGE_ACCESS_LOADING:
            return {
                ...state,
                subContractorStageAccess: {
                    ...state.subContractorStageAccess,
                    get: {
                        ...state.subContractorStageAccess.get,
                        loading: true,
                        reset: false,
                        success: {
                            ...state.subContractorStageAccess.get.success,
                            ok: false,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_SUB_CONTRACTOR_STAGE_ACCESS_SUCCESS:
            return {
                ...state,
                subContractorStageAccess: {
                    ...state.subContractorStageAccess,
                    get: {
                        ...state.subContractorStageAccess.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.subContractorStageAccess.get.success,
                            ok: true,
                            data: action.payload,
                        },
                        failure: {
                            error: false,
                            message: '',
                        },
                    },
                },
            };
        case GET_SUB_CONTRACTOR_STAGE_ACCESS_FAILURE:
            return {
                ...state,
                subContractorStageAccess: {
                    ...state.subContractorStageAccess,
                    get: {
                        ...state.subContractorStageAccess.get,
                        loading: false,
                        reset: false,
                        success: {
                            ...state.subContractorStageAccess.get.success,
                            ok: false,
                            data: null,
                        },
                        failure: {
                            error: true,
                            message: action.payload.message,
                        },
                    },
                },
            };
    }
    return state;
}

export default subContractorStageAccessReducers;